<template>
  <div :class="theme" class="user-wrapper">
    <user-tenant>
      <!-- <a-icon type="fund"></a-icon> -->
    </user-tenant>
    <a-tooltip title="搜索菜单">
      <span @click="showClick" class="action">
        <a-icon type="search"></a-icon>
      </span>
    </a-tooltip>
    <!-- update-begin author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框 -->
    <component
      :footer="null"
      :is="searchMenuComp"
      :visible="searchMenuVisible"
      @cancel="searchMenuVisible = false"
      class="borders"
      title="搜索菜单"
      v-show="searchMenuVisible || isMobile()"
    >
      <a-select
        :filterOption="filterOption"
        :getPopupContainer="node => node.parentNode"
        :open="isMobile() ? true : null"
        :showArrow="false"
        :style="isMobile() ? { width: '100%', marginBottom: '50px' } : {}"
        @blur="hiddenClick"
        @change="searchMethods"
        class="search-input"
        optionFilterProp="children"
        placeholder="搜索菜单"
        showSearch
      >
        <a-select-option :key="index" :value="site.id" v-for="(site, index) in searchMenuOptions">
          {{
          site.meta.title
          }}
        </a-select-option>
      </a-select>
    </component>
    <a-tooltip title="通知/消息">
      <header-notice class="action" />
    </a-tooltip>

    <a-tooltip title="AI助手" v-if=" !userInfo().thirdAccount || corpInfo.maintenancePermission === 1">
      <span class="action">
        <a @click="handleItrecord" class="logout_title" href="javascript:;">
          <i class="anticon-jeecg anticon-jiqiren"></i>
        </a>
      </span>
    </a-tooltip>
    <a-dropdown>
      <span class="action action-full ant-dropdown-link user-dropdown-menu">
        <a-avatar :src="getAvatar()" class="avatar" size="small" />
        <span v-if="isDesktop()">欢迎您，{{ nickname() }}</span>
      </span>
      <a-menu class="user-dropdown-menu-wrapper" slot="overlay">
        <a-menu-item @click="systemSetting" key="3">
          <a-icon type="tool" />
          <span>系统设置</span>
        </a-menu-item>
        <a-menu-item @click="workbenchSetting" key="7">
          <a-icon type="plus" />
          <span>工作台组件</span>
        </a-menu-item>
        <a-menu-item @click="updatePassword" key="4">
          <a-icon type="setting" />
          <span>密码修改</span>
        </a-menu-item>
        <a-menu-item @click="clearCache" key="6">
          <a-icon type="sync" />
          <span>清理缓存</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <span class="action">
      <a @click="handleLogout" class="logout_title" href="javascript:;">
        <a-icon type="logout" />
        <span v-if="isDesktop()">&nbsp;退出登录</span>
      </a>
    </span>
    <workbench-setting ref="workbench"></workbench-setting>

    <user-password ref="userPassword"></user-password>
    <depart-select :closable="true" ref="departSelect" title="部门切换"></depart-select>
    <setting-drawer :closable="true" ref="settingDrawer" title="系统设置"></setting-drawer>

    <chat-drawer :closable="true" ref="chatDrawer" title="iPlus知识问答"></chat-drawer>
    <embedding-drawer :closable="true" ref="embeddingDrawer" title="AI 助手"></embedding-drawer>
  </div>
</template>

<script>
  import HeaderNotice from './HeaderNotice'
  import UserPassword from './UserPassword'
  import WorkbenchSetting from './Workbench'
  import ChatDrawer from '@/components/bigmodel/ChatDrawer'
  import EmbeddingDrawer from '@/components/bigmodel/EmbeddingDrawer.vue'

  import SettingDrawer from '@/components/setting/SettingDrawer'
  import DepartSelect from './DepartSelect'
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
  import { mixinDevice } from '@/utils/mixin.js'
  import { getFileAccessHttpUrl, getAction } from '@/api/manage'
  import Vue from 'vue'
  import { UI_CACHE_DB_DICT_DATA } from '@/store/mutation-types'
  import UserTenant from './UserTenant.vue'
  import router from '@/router/index'

  export default {
    name: 'UserMenu',
    mixins: [mixinDevice],
    data () {
      return {
        // update-begin author:sunjianlei date:20200219 for: 头部菜单搜索规范命名 --------------
        searchMenuOptions: [],
        searchMenuComp: 'span',
        searchMenuVisible: false
        // update-begin author:sunjianlei date:20200219 for: 头部菜单搜索规范命名 --------------
      }
    },
    components: {
      WorkbenchSetting,
      HeaderNotice,
      UserPassword,
      DepartSelect,
      SettingDrawer,
      UserTenant,
      ChatDrawer,
      EmbeddingDrawer
    },
    props: {
      theme: {
        type: String,
        required: false,
        default: 'dark'
      }
    },
    /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
    created () {
      let lists = []
      this.searchMenus(lists, this.permissionMenuList)
      this.searchMenuOptions = [...lists]
      this.SET_ROUTE_LIST(this.searchMenuOptions)
      // 判断用户是否有告警中心权限
      const hasAlertCenterMenuAuth = lists.find(item => item.meta.componentName == 'IotAlertList')
      if (hasAlertCenterMenuAuth) {
        this.$store.commit('SET_ALERT_MENU_AUTH', true)
      }
    },
    mounted () {
      //如果是单点登录模式
      if (process.env.VUE_APP_SSO == 'true') {
        let depart = this.userInfo().orgCode
        if (!depart) {
          this.updateCurrentDepart()
        }
      }
    },
    computed: {
      ...mapState({
        // 后台菜单
        permissionMenuList: state => state.user.permissionList,
      }),
      corpInfo () {
        return this.userInfo().corpInfo || {}
      }
    },
    /* update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
    watch: {
      // update-begin author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框
      device: {
        immediate: true,
        handler () {
          this.searchMenuVisible = false
          this.searchMenuComp = this.isMobile() ? 'a-modal' : 'span'
        }
      }
      // update-end author:sunjianlei date:20200219 for: 菜单搜索改为动态组件，在手机端呈现出弹出框
    },
    methods: {
      /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
      showClick () {
        this.searchMenuVisible = true
      },
      hiddenClick () {
        this.shows = false
      },
      /* update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
      ...mapActions(['Logout']),
      ...mapMutations(['SET_ROUTE_LIST']),
      ...mapGetters(['nickname', 'avatar', 'userInfo']),
      getAvatar () {
        return getFileAccessHttpUrl(this.avatar())
      },
      handleLogout () {
        const that = this

        this.$confirm({
          title: '提示',
          content: '真的要注销登录吗 ?',
          onOk () {
            return that
              .Logout({})
              .then(() => {
                //         $route: {
                // handler: function(route) {
                //   // 需要进行解码\

                let redirectPath = decodeURIComponent(that.$route.fullPath).split('redirect=')[1]
                //   this.redirect = redirectPath
                // },
                // immediate: true
                // }
                // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
                // that.$router.push({ path: '/user/login', query: { redirect: that.$route.fullPath } });
                // this.$store.commit('CLEAR_ADDROUTES', [])
                router.addRoutes([])
                that.$router.push({ path: '/user/login' })
                // window.location.reload()
                // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
              })
              .catch(err => {
                that.$message.error({
                  title: '错误',
                  description: err.message
                })
              })
          },
          onCancel () { }
        })
      },
      updatePassword () {
        let username = this.userInfo().username
        this.$refs.userPassword.show(username)
      },
      workbenchSetting () {
        this.$refs.workbench.show()
      },
      updateCurrentDepart () {
        this.$refs.departSelect.show()
      },
      systemSetting () {
        this.$refs.settingDrawer.showDrawer()
      },
      /* update_begin author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
      searchMenus (arr, menus) {
        for (let i of menus) {
          if (!i.hidden && 'layouts/RouteView' !== i.component) {
            arr.push(i)
          }
          if (i.children && i.children.length > 0) {
            this.searchMenus(arr, i.children)
          }
        }
      },
      filterOption (input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      // update_begin author:sunjianlei date:20191230 for: 解决外部链接打开失败的问题
      searchMethods (value) {
        let route = this.searchMenuOptions.filter(item => item.id === value)[0]
        //update-begin-author:taoyan date:20210528 for: 【菜单问题】配置一个iframe地址的菜单，内部打开，在搜索菜单上打开却新开了一个窗口
        if (route.meta.internalOrExternal === true) {
          window.open(route.meta.url, '_blank')
        } else {
          if (route.component.includes('layouts/IframePageView')) {
            this.$router.push(route)
          } else {
            this.$router.push({ path: route.path })
          }
        }
        //update-end-author:taoyan date:20210528 for: 【菜单问题】配置一个iframe地址的菜单，内部打开，在搜索菜单上打开却新开了一个窗口
        this.searchMenuVisible = false
      },
      // update_end author:sunjianlei date:20191230 for: 解决外部链接打开失败的问题
      /*update_end author:zhaoxin date:20191129 for: 做头部菜单栏导航*/
      /*update_begin author:liushaoqian date:20200507 for: 刷新缓存*/
      clearCache () {
        getAction('sys/dict/refleshCache')
          .then(res => {
            if (res.success) {
              //重新加载缓存
              getAction('sys/dict/queryAllDictItems').then(res => {
                if (res.success) {
                  Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
                  Vue.ls.set(UI_CACHE_DB_DICT_DATA, res.result, 7 * 24 * 60 * 60 * 1000)
                }
              })
              this.$message.success('刷新缓存完成！')
            }
          })
          .catch(e => {
            this.$message.warn('刷新缓存失败！')
            console.log('刷新失败', e)
          })
      },
      /*update_end author:liushaoqian date:20200507 for: 刷新缓存*/
      handleItrecord: function () {
        // this.$router.push({ path: '/intelligent/duty' })
        // this.$refs.chatDrawer.showDrawer()
        this.$refs.embeddingDrawer.show()
      }
    }
  }
</script>

<style lang="less" scoped>
  /* update_begin author:zhaoxin date:20191129 for: 让搜索框颜色能随主题颜色变换*/
  /* update-begin author:sunjianlei date:20191220 for: 解决全局样式冲突问题 */
  .user-wrapper .search-input {
    width: 180px;
    color: inherit;

    /deep/ .ant-select-selection {
      background-color: inherit;
      border: 0;
      border-bottom: 1px solid white;
      &__placeholder,
      &__field__placeholder {
        color: inherit;
      }
    }
  }
  /* update-end author:sunjianlei date:20191220 for: 解决全局样式冲突问题 */
  /* update_end author:zhaoxin date:20191129 for: 让搜索框颜色能随主题颜色变换*/
</style>

<style scoped>

  .logout_title {
    color: inherit;
    text-decoration: none;
  }

</style>
